export const CEFR_J_LEVELS = [
  {
    display: "Pre A1",
    cefrjMap: [1]
  },
  {
    display: "A1.1",
    cefrjMap: [2]
  },
  {
    display: "A1.2",
    cefrjMap: [3]
  },
  {
    display: "A1.3",
    cefrjMap: [4]
  },
  {
    display: "A2.1",
    cefrjMap: [5]
  },
  {
    display: "A2.2",
    cefrjMap: [6]
  },
  {
    display: "B1.1",
    cefrjMap: [7]
  },
  {
    display: "B1.2",
    cefrjMap: [8]
  },
  {
    display: "B2.1",
    cefrjMap: [9]
  },
  {
    display: "B2.2",
    cefrjMap: [10]
  },
  {
    display: "C1",
    cefrjMap: [11]
  },
  {
    display: "C2",
    cefrjMap: [12]
  }
];

export const EIKEN_LEVELS = [
  {
    display: "5級",
    cefrjMap: [1, 2]
  },
  {
    display: "4級",
    cefrjMap: [2, 3]
  },
  {
    display: "3級",
    cefrjMap: [4, 5, 6, 7]
  },
  {
    display: "準2級",
    cefrjMap: [5, 6, 7, 8]
  },
  {
    display: "2級",
    cefrjMap: [7, 8, 9, 10]
  },
  {
    display: "準1級",
    cefrjMap: [9, 10, 11]
  },
  {
    display: "1級",
    cefrjMap: [11, 12]
  }
];

export const TOEIC_LEVELS = [
  {
    display: "~ 120",
    cefrjMap: [1]
  },
  {
    display: "125 ~ 160",
    cefrjMap: [2]
  },
  {
    display: "165 ~ 185",
    cefrjMap: [3]
  },
  {
    display: "190 ~ 230",
    cefrjMap: [4]
  },
  {
    display: "235 ~ 405",
    cefrjMap: [5]
  },
  {
    display: "410 ~ 545",
    cefrjMap: [6]
  },
  {
    display: "550 ~ 665",
    cefrjMap: [7]
  },
  {
    display: "670 ~ 780",
    cefrjMap: [8]
  },
  {
    display: "785 ~ 865",
    cefrjMap: [9]
  },
  {
    display: "870 ~ 940",
    cefrjMap: [10]
  },
  {
    display: "945 ~",
    cefrjMap: [11, 12]
  }
];

export const EXAMS = [
  {
    name: "CEFR-J",
    levels: CEFR_J_LEVELS
  },
  {
    name: "英検®",
    levels: EIKEN_LEVELS
  },
  {
    name: "TOEIC®",
    levels: TOEIC_LEVELS
  }
];
